module.exports = __webpack_public_path__ + "static/master-img3-5a988b3396a32314cbd88330aee43d21.jpg";